import NumberFormat from "react-number-format";
import SelectField from "../../../../components/common/form/SelectField";
import {createOptionListForSelectTag} from "../../../../helpers/utils/Utils";
import React from "react";

export function exemptionLabel() {
    return (<>
        <div className="col-span-12 grid grid-cols-12 gap-3 mt-5 font-semibold">
            <label className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">Exemptions</label>
            <div className="relative col-span-5 flex">
                <div className="w-full">Type</div>
            </div>
            <div className="relative col-span-4 flex ">
                <div className="w-full">Flat Amount</div>
                <div className="w-full">% Amount</div>

            </div>
        </div>

    </>)
}


interface EnumOption {
    value: string;
    constant: string;
}

interface Props {
    enums: EnumOption[];
    name: string;
    type: string;
    setType: (value: string) => void;
    flatAmount: string;
    setFlatAmount: (value: string) => void;
    perAmount: string;
    setPerAmount: (value: string) => void;
    formType?: string | null;
    setEditable?: (value: boolean) => void;
    isReadOnly?: boolean;
    setShowButtons?: any;
}

const isInt = (n: any): boolean => Number(n) === n && n % 1 === 0;

const resetExemptionField = (
    setType: (value: string) => void,
    setFlatAmount: (value: string) => void,
    setPerAmount: (value: string) => void
) => {
    setType("NONE");
    setFlatAmount("");
    setPerAmount("");
};

export const ExemptionField: React.FC<Props> = ({
                                                    enums,
                                                    name,
                                                    type,
                                                    setType,
                                                    flatAmount,
                                                    setFlatAmount,
                                                    perAmount,
                                                    setPerAmount,
                                                    formType = null,
                                                    setEditable = null,
                                                    isReadOnly = false,
                                                    setShowButtons = null,
                                                }) => {
    const formattedOptions = enums.map((opt) => ({
        label: opt.constant,
        value: opt.value,
    }));


    const handleExemptionChange = (
        selectedOption: { value: string } | null,
        setType: (value: string) => void,
        setFlatAmount: (value: string) => void,
        setPerAmount: (value: string) => void,
        formType: string | null,
        setShowButtons: any | null,
    ) => {
        const value = selectedOption?.value ?? "";

        if (formType === "Update") {
            setShowButtons?.(true);
        }

        if (value === "NONE") {
            setFlatAmount("");
            setPerAmount("");
        } else if (value === "FLAT") {
            setPerAmount("");
        } else if (value === "PERCENTAGE") {
            setFlatAmount("");
        }

        setType(value);
    };


    const selectedOption = formattedOptions.find((opt) => opt.label === type);
    return (
        <div className="col-span-12 grid grid-cols-12 gap-3 mt-3">
            <div className="col-span-3  flex items-center">
                <label className="min-w-[100px]">{name}</label>
            </div>
            <div className="relative col-span-9 flex items-center gap-3">
                <div className="w-full">

                    <SelectField
                        options={createOptionListForSelectTag(enums, "value", "constant")}
                        placeholder="Select Exemption..."
                        onChange={(selectedOption) =>
                            handleExemptionChange(
                                selectedOption,
                                setType,
                                setFlatAmount,
                                setPerAmount,
                                formType,
                                setShowButtons
                            )
                        }
                        isDisabled={isReadOnly}
                        value={selectedOption}
                        required={false}
                        label=""
                        hideLabel
                        className="col-span-10 "
                    />
                </div>

                <div className="w-60">
                    <NumberFormat
                        placeholder="..."
                        className="form-control border border-surface-5"
                        isNumericString={flatAmount !== null || flatAmount !== ""}
                        value={flatAmount}
                        prefix={flatAmount !== null && flatAmount !== "" ? "$" : ""}
                        onKeyDown={(event: any) => {
                            if (event.key === "." || event.key === "-") {
                                event.preventDefault();
                            }
                        }}
                        onChange={(e: any) => {
                            if (formType !== "Create") {
                                setShowButtons?.(true);
                            }
                            setFlatAmount(e.target.value.replace("$", "").replaceAll(",", ""));
                        }}
                        thousandSeparator={true}
                        disabled={type === "NONE" || type === "PERCENTAGE" || isReadOnly}
                    />
                </div>

                <div className="w-60">
                    <NumberFormat
                        placeholder="..."
                        className="form-control border border-surface-5"
                        isNumericString={perAmount !== null || perAmount !== ""}
                        value={isInt(parseFloat(perAmount)) ? parseFloat(perAmount) : parseFloat(perAmount) * 100}
                        onKeyDown={(event: any) => {
                            if (event.key === "." || event.key === "-") {
                                event.preventDefault();
                            }
                        }}
                        onChange={(e: any) => {
                            if (formType !== "Create") {
                                setShowButtons?.(true);
                            }
                            e.target.value = +e.target.value > 100 ? "" : e.target.value;
                            setPerAmount(e.target.value);
                        }}
                        disabled={type === "NONE" || type === "FLAT" || isReadOnly}
                    />
                </div>

                {!isReadOnly && (
                    <div className="w-1/12 mt-1" title="Clear Exemption">
                        <i
                            className="fa fa-solid fa-rotate-left cursor-pointer  text-highlight-0"
                            onClick={() => resetExemptionField(setType, setFlatAmount, setPerAmount)}
                        />
                    </div>
                )}
            </div>
        </div>


    );
};
